<app-text [alias]="'instructor_main_page'" [interpolationObject]="currentSchedule"></app-text>
<div>
<app-object-list-term-list
        [termCode]="currentTermCode"
        [section]="currentSection"
        [showTermNotAvailable]="showTermNotAvailable"
        (selectedTermCode)="updateSelectedTermCode($event)"
        (sectionChangeEvent)="updateSection($event)"
        [enabled]="enableTermDropDown"></app-object-list-term-list>
</div>
<div>
    <app-course-course-list
            *ngIf="currentTermCode"
            [termCode]="currentTermCode"
            [section]="currentSection"
            (hasDataLoaded)="updateCourseDataLoaded($event)"  ></app-course-course-list>
</div>
